<template>
  <sfs-form-modal
    :id="modalId"
    title="Add an Item"
    @on-hide="resetFormData"
  >
    <technician-payment-item-form
      @on-submit="createItem"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import TechnicianPaymentItemForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'TechnicianPaymentItemAddModal',
  mixins: [formModalMixin],
  components: {
    TechnicianPaymentItemForm,
  },
  props: {
    technician_payment_id: Number,
  },
  data() {
    return {
      modalId: 'technician-payment-item-add-modal',
    };
  },
  methods: {
    createItem(data, handleCreate) {
      handleCreate(this.$technicianPaymentsAPI.createItem(this.technician_payment_id, data));
    },
    onSave() {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save');
    },
  },
};
</script>
